import { ROLE_SALES_MANAGER } from './constants';

export const saveUserToLocal = (user, saveToken) => {
  const userRoles = Array.isArray(user.roles) && user.roles.length > 0 ? user.roles : [];

  localStorage.removeItem('user-role');

  localStorage.setItem('user-email', user['email']);
  localStorage.setItem('user-name', user['name']);
  localStorage.setItem('user-roles', JSON.stringify(userRoles));
  localStorage.setItem('user-sales-location', JSON.stringify(user['salesLocation']));
  localStorage.setItem('user-sales-locations', JSON.stringify(Array.isArray(user['salesLocations']) ? user['salesLocations'] : []));

  if (user['installer']) localStorage.setItem('installer', JSON.stringify(user['installer']));

  if (userRoles.some(r => r.toLowerCase() === ROLE_SALES_MANAGER.toLowerCase())) {
    localStorage.setItem('salesRep', JSON.stringify(user['salesReps']));
  }

  const requiredFields = ['name', 'email', 'phone', '_id'];
  const userJSON = {};
  requiredFields.forEach(f => (userJSON[f] = user[f]));
  userJSON.roles = userRoles;
  localStorage.setItem('user', JSON.stringify(userJSON));
};

export const getSalesRepOfSalesManager = () => {
  let returnArray = [];
  try {
    returnArray = JSON.parse(localStorage.getItem('salesRep'));
  } catch (e) {}
  return returnArray;
};

export const getProfileFromLocalStorage = () => {
  try {
    const profile = localStorage.getItem('user');
    return JSON.parse(profile);
  } catch (e) {}
  return {};
};
